import { Outlet } from "react-router-dom";
import TopNav from "../Menus/TopNav";
import SideNavMenu from "../Menus/SideNavMenu";
import { useLayoutStore } from "../../context";
import { motion } from "framer-motion";

export default function AuthLayout({ children }) {
  const isSidebarOpen = useLayoutStore((state) => state.isSidebarOpen);

  return (
    <div className="flex h-screen flex-col">
      <TopNav />
      <div className="flex flex-1 overflow-x-hidden bg-gray-50">
        <SideNavMenu />
        <motion.div
          animate={{ marginLeft: isSidebarOpen ? "16rem" : "0rem" }}
          transition={{ type: "spring", stiffness: 95, damping: 20 }}
          className={`mt-16 flex-1 overflow-auto max-w-full`}
        >
          <Outlet />
        </motion.div>
      </div>
    </div>
  );
}
